// extracted by mini-css-extract-plugin
module.exports = {"save-to-my-profile":"C30_SaveToMyProfile_save-to-my-profile__c4Miu"};